/**
 * Copyright(c) 2023 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @author Indrajith C
 */

const locales = process.env.SYSTEM_ENV_LOCALES?.split(",") ?? [];
const defaultLocale = process.env.SYSTEM_ENV_DEFAULT_LOCALE ?? "";
export const i18n = {
  defaultLocale,
  locales: locales,
} as const;

export type Locale = (typeof i18n)["locales"][number];
